import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface SearchHistoryValue {
  srnNumber: string;
  searchType: string;
}

export interface SearchHistorySliceStateType {
  panSearchHistoryValue: SearchHistoryValue | null;
  itrSearchHistoryValue: SearchHistoryValue | null;
  dscSearchHistoryValue: SearchHistoryValue | null;
  gumastaSearchHistoryValue: SearchHistoryValue | null;
  msmeSearchHistoryValue: SearchHistoryValue | null;
}

const initialState: SearchHistorySliceStateType = {
  panSearchHistoryValue: null,
  itrSearchHistoryValue: null,
  dscSearchHistoryValue: null,
  gumastaSearchHistoryValue: null,
  msmeSearchHistoryValue: null,
};

const searchHistorySlice: any = createSlice({
  name: "searchHistorySlice",
  initialState,
  reducers: {
    setPanSearchHistoryValue: (state, action: PayloadAction<{ srnNumber: string; searchType: string }>) => {
       console.log("PAN reducer payload →", {
        srnNumber: action.payload.srnNumber,
        searchType: action.payload.searchType,
      });
      state.panSearchHistoryValue = action.payload;
    },
    setItrSearchHistoryValue: (state, action: PayloadAction<{ srnNumber: string; searchType: string }>) => {
       console.log("PAN reducer payload →", {
        srnNumber: action.payload.srnNumber,
        searchType: action.payload.searchType,
      });
      state.itrSearchHistoryValue = action.payload;
    },
    setDscSearchHistoryValue: (state, action: PayloadAction<{ srnNumber: string; searchType: string }>) => {
       console.log("PAN reducer payload →", {
        srnNumber: action.payload.srnNumber,
        searchType: action.payload.searchType,
      });
      state.dscSearchHistoryValue = action.payload;
    },
    setGumastaSearchHistoryValue: (state, action: PayloadAction<{ srnNumber: string; searchType: string }>) => {
       console.log("PAN reducer payload →", {
        srnNumber: action.payload.srnNumber,
        searchType: action.payload.searchType,
      });
      state.gumastaSearchHistoryValue = action.payload;
    },
    setMsmeSearchHistoryValue: (state, action: PayloadAction<{ srnNumber: string; searchType: string }>) => {
       console.log("PAN reducer payload →", {
        srnNumber: action.payload.srnNumber,
        searchType: action.payload.searchType,
      });
      state.msmeSearchHistoryValue = action.payload;
    },
  },
});

export const {
  setDscSearchHistoryValue,
  setGumastaSearchHistoryValue,
  setItrSearchHistoryValue,
  setMsmeSearchHistoryValue,
  setPanSearchHistoryValue,
} = searchHistorySlice.actions;
export default searchHistorySlice.reducer;
